export enum YesNo {
  Yes = 'Yes',
  No = 'No',
}

export function yesNoToBoolean(yesNo: YesNo): boolean {
  return yesNo === YesNo.Yes;
}

export function booleanToYesNo(value: boolean): YesNo {
  return value ? YesNo.Yes : YesNo.No;
}
